<template>
    <div class="bg-white rounded-2xl border border-gray-200 p-4 space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Clôture du chantier</p>
            <p class="text-sm text-slate-500 mt-0.5">Indiquez si ce chantier est terminé ou nécessite un retour.</p>
        </div>

        <!-- Loading vérification -->
        <div v-if="checkingCanEnd" class="flex items-center py-4 text-orange-600">
            <i class="fas fa-spinner fa-spin mr-1"></i>
            <span class="text-sm font-medium">Vérification du chantier…</span>
        </div>

        <!-- Autres interventions planifiées → on ne peut pas clôturer -->
        <div v-else-if="canEndChantier === false && needReturn === null" class="space-y-4">
            <div class="bg-amber-50 border border-amber-200 rounded-2xl p-4">
                <p class="font-semibold text-amber-800 mb-1">D'autres interventions sont planifiées</p>
                <p class="text-sm text-amber-700">
                    Ce chantier a encore des passages à venir. Terminez cette intervention sans clôturer le chantier.
                </p>
            </div>
            <button
                class="w-full flex items-center justify-center gap-2 py-3.5 bg-green-600 hover:bg-green-700 text-white rounded-xl text-sm font-semibold transition-colors"
                @click="forceEnd"
            >
                <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5l-4-4 1.41-1.41L10 13.67l6.59-6.59L18 8.5l-8 8z"/></svg>
                Terminer l'intervention
            </button>
        </div>

        <!-- Choix libre (peut clôturer) -->
        <template v-else-if="canEndChantier === true">
            <div class="grid grid-cols-2 gap-3">
                <!-- Retour nécessaire -->
                <button
                    class="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all"
                    :class="needReturn === true
                        ? 'bg-orange-500 border-orange-500 text-white'
                        : 'bg-white border-gray-200 text-slate-700 hover:border-orange-300'"
                    @click="selectNeedReturn(true)"
                >
                    <svg class="w-7 h-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/>
                    </svg>
                    <p class="text-sm font-bold">Retour nécessaire</p>
                    <p class="text-xs opacity-75">Replanifier</p>
                </button>

                <!-- Oui terminé -->
                <button
                    class="flex flex-col items-center gap-2 p-4 rounded-2xl border-2 transition-all"
                    :class="needReturn === false
                        ? 'bg-green-500 border-green-500 text-white'
                        : 'bg-white border-gray-200 text-slate-700 hover:border-green-300'"
                    @click="selectNeedReturn(false)"
                >
                    <svg class="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5l-4-4 1.41-1.41L10 13.67l6.59-6.59L18 8.5l-8 8z"/>
                    </svg>
                    <p class="text-sm font-bold">Oui, terminé</p>
                    <p class="text-xs opacity-75">Clôture du chantier</p>
                </button>
            </div>

            <!-- Motif du retour -->
            <div v-if="needReturn === true" class="space-y-2">
                <label class="text-xs font-semibold text-slate-500">Motif du retour *</label>
                <textarea
                    v-model="localReturnReason"
                    class="w-full border border-gray-200 rounded-xl px-3 py-3 text-sm outline-none focus:border-blue-500 resize-none"
                    rows="3"
                    placeholder="Ex : pièce en attente, validation client requise…"
                    @input="onReturnReasonChange"
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'StepChantierEnd',
    inject: ['wm'],

    props: {
        canEndChantier: { type: Boolean, default: null },
        checkingCanEnd: { type: Boolean, default: false },
        needReturn:     { type: Boolean, default: null },
        returnReason:   { type: String,  default: '' },
    },

    data() {
        return {
            localReturnReason: this.returnReason,
        };
    },

    methods: {
        selectNeedReturn(val) {
            this.wm.needReturn = val;
            this.wm.updateFormData({
                chantier_repassage: val,
                chantier_repassage_motif: val ? '' : '',
            });
        },

        onReturnReasonChange() {
            this.wm.returnReason = this.localReturnReason;
            this.wm.updateFormData({ chantier_repassage_motif: this.localReturnReason });
        },

        forceEnd() {
            this.wm.needReturn = true;
            this.wm.updateFormData({
                chantier_repassage: true,
                chantier_repassage_motif: 'Interventions planifiées à venir',
            });
            this.$emit('finalize', { signatureMode: null, finChantier: false });
        },
    },
};
</script>
